import { render, staticRenderFns } from "./addRecordYouthToSquadAudit.vue?vue&type=template&id=6770026c&"
import script from "./addRecordYouthToSquadAudit.vue?vue&type=script&lang=js&"
export * from "./addRecordYouthToSquadAudit.vue?vue&type=script&lang=js&"
import style0 from "./addRecordYouthToSquadAudit.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports